import React from 'react';

import { AxiosError } from 'axios';

export function GetFormattedData(props: any) {
    return (
        <span>
            {new Date(props.data).toLocaleString(localStorage.getItem('codLingua')?.toString(), {
                dateStyle: 'medium',
            })}
        </span>
    );
}

export function GetFormattedDataOra(props: any) {
    return (
        <span>
            {new Date(props.data).toLocaleString(localStorage.getItem('codLingua')?.toString(), {
                dateStyle: 'medium',
                timeStyle: 'short',
            })}
        </span>
    );
}

export function isValidDateValue(dateValue: any) {
    const date = new Date(dateValue);
    return !isNaN(date.getTime());
}

export function GetErrorMessage(error: any | Error | AxiosError) {
    try {
        let message: string;

        if (error instanceof AxiosError) {
            const erx = error as AxiosError;
            message = erx.message;
            if (erx.response?.data !== null) {
                message = erx.message + '-' + erx.response?.data;
            }
        } else if (error.response?.data !== null && error.response?.data !== '') {
            message = error.response?.data.message;
        } else message = error.response.status + ' - ' + error.response.statusText;
        return message;
    } catch (err) {
        return 'Unmanaged error!';
    }
}
